import { PartnerExpoStand } from 'elements/hardwareSelectorV2/types'
import { ComponentVersionsInherit, Link, OsTooltipVersion, styled } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { FC } from 'react'
import { ToolTipRestyle } from 'resources/projects/projects3/styles'
import { useFeatureFlag } from 'util/featureFlags'
import ExpoRibbonTag from './ExpoRibbonTag'

const Content = styled('div', { name: 'Content' })({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  fontWeight: 600,
  fontSize: 15,
  '& p': {
    margin: 0,
    fontSize: 15,
  },
  '& .desc': {
    fontWeight: 400,
  },
})

const StyledLink = styled(Link, { name: 'ExpoTooltipStyledLink' })(({ theme }) => ({
  background: theme.palette.neutralGrey[200],
  width: '100px',
  padding: '10px 20px',
  borderRadius: '5px',
  textDecoration: 'none',
  textAlign: 'center',
  fontWeight: 500,
  // Override MUI Tooltip's
  '&&': {
    color: `${theme.palette.neutralGrey[1000]} !important`,
  },
  '&:hover': {
    background: theme.palette.neutralGrey[300],
    textDecoration: 'none',
  },
}))

const ExpoTooltip: FC<PartnerExpoStand> = (props) => {
  const translate = useTranslate()
  const expoEnabled = useFeatureFlag('expo', 'on')
  const isExpoHookEnabled = useFeatureFlag('expo_hook', 'on')
  if (!expoEnabled || !isExpoHookEnabled) return null
  return (
    <ComponentVersionsInherit versions={{ tooltip: OsTooltipVersion.V2 }}>
      <ToolTipRestyle title={<TipContent {...props} />} placement="top" arrow interactive leaveDelay={300}>
        <div>
          <ExpoRibbonTag text={translate('Expo Partner')} />
        </div>
      </ToolTipRestyle>
    </ComponentVersionsInherit>
  )
}

const TipContent: FC<PartnerExpoStand> = ({ slug }) => {
  const translate = useTranslate()
  return (
    <Content onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
      {/* Prevent clicks inside the tooltip from bubbling to the ProductTile's onClick, which would navigate to the product page */}
      <p>{translate('Expo Partner')}</p>
      <p className="desc">{translate("See more products and information by visiting the partner's expo stand.")}</p>
      <StyledLink href={'/expo/' + slug} target="_blank" rel="noopener noreferrer">
        {translate('Visit Stand')}
      </StyledLink>
    </Content>
  )
}

export default ExpoTooltip
